import { useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import { Body, Container, Top } from "./localStyle";

const ModalLaboPrep = ({ dissmiss }) => {
  const { textosState } = useContext(PortalContext);
  const textoVisualizar = textosState?.textos?.data?.msjPreparacionesPorDefLabo;

  return (
    <Container>
      <Top>
        <span
          dangerouslySetInnerHTML={{
            __html: textoVisualizar?.nombre,
          }}
        />
        <div className="cruz" onClick={dissmiss}>
          X
        </div>
      </Top>

      <Body>
        <span
          dangerouslySetInnerHTML={{
            __html: textoVisualizar?.descripcion,
          }}
        />
      </Body>
      <button onClick={dissmiss}>Confirmo que leí la preparación</button>
    </Container>
  );
};
export default ModalLaboPrep;
